// Yield configuration payload (camelCase — matches the API response/request
// aliases of the backend YieldConfigData schema).
export interface IYieldConfigData {
  yieldPerRaiPerYear: number;
  janPct: number;
  febPct: number;
  marPct: number;
  aprPct: number;
  mayPct: number;
  junPct: number;
  julPct: number;
  augPct: number;
  sepPct: number;
  octPct: number;
  novPct: number;
  decPct: number;
}

// Field keys for just the 12 monthly percentages.
export type TMonthlyPctField =
  | "janPct"
  | "febPct"
  | "marPct"
  | "aprPct"
  | "mayPct"
  | "junPct"
  | "julPct"
  | "augPct"
  | "sepPct"
  | "octPct"
  | "novPct"
  | "decPct";

export interface IMonthDef {
  // i18n key under yieldConfig.months
  key: string;
  // formik / payload field
  field: TMonthlyPctField;
}

// Ordered Jan–Dec so the grid and the running total always line up.
export const YIELD_MONTHS: IMonthDef[] = [
  { key: "jan", field: "janPct" },
  { key: "feb", field: "febPct" },
  { key: "mar", field: "marPct" },
  { key: "apr", field: "aprPct" },
  { key: "may", field: "mayPct" },
  { key: "jun", field: "junPct" },
  { key: "jul", field: "julPct" },
  { key: "aug", field: "augPct" },
  { key: "sep", field: "sepPct" },
  { key: "oct", field: "octPct" },
  { key: "nov", field: "novPct" },
  { key: "dec", field: "decPct" },
];

// All-zero defaults used when the client has no saved configuration yet.
export const EMPTY_YIELD_CONFIG: IYieldConfigData = {
  yieldPerRaiPerYear: 0,
  janPct: 0,
  febPct: 0,
  marPct: 0,
  aprPct: 0,
  mayPct: 0,
  junPct: 0,
  julPct: 0,
  augPct: 0,
  sepPct: 0,
  octPct: 0,
  novPct: 0,
  decPct: 0,
};

// Tolerance for the "sum of 12 months == 100" check (mirrors the backend).
export const SUM_TOLERANCE = 0.01;
